// import { useState, useEffect } from "react";
// import "./WorkScreen.css";
// import Download from "./Download/Download";
// import {
//   Card,
//   Col,
//   Container,
//   Row,
//   Button,
//   Modal,
//   InputGroup,
//   Form,
// } from "react-bootstrap";
// import Draggable from "react-draggable";
// import { FaMinus } from "react-icons/fa";
// import { GoLink } from "react-icons/go";
// import { ReactComponent as CloseIcon } from "../../../assets/images/cross-icon.svg";
// import { ReactComponent as CopyIcon } from "../../../assets/images/copy-icon.svg";
// import IssueIcon from "../../../assets/images/issue-icon.png";
// import DownloadIcon from "../../../assets/images/download-icon.png";
// import HistorySection from "./HistorySection";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   fetchWorkScreenData,
//   postWorkScreenData,
//   getMemberId,
//   fetchFilteredTableDataInit,
//   getOperationDataInit,
// } from "../../../redux/slices/operationHomeSlice";
// import { useNavigate } from "react-router-dom";
// import Spinner from "../../../common/components/Spinner/Spinner";
// import WorkBtnImg from "../../../assets/images/work-send-btn.png";
// import Ellipse1 from "../../../assets/images/Ellipse 1.png";
// // import Downloadall from "../WorkScreen/DownloadAll";

// function WorkScreen({ value, callId }) {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const data = useSelector((state) => state.operationHome.workScreenData);
//   console.log(data);
//   console.log(data);
//   const isWorkScreenLoading = useSelector(
//     (state) => state.operationHome.isWorkScreenLoading
//   );
//   const currentPage = useSelector(
//     (state) => state.operationHome.table.currentPage
//   );
//   const pageSize = useSelector((state) => state.operationHome.table.pageSize);
//   const searchFields = useSelector((state) => state.operationHome.searchFields);
//   const activeTab = useSelector((state) => state.operationHome.activeTab);
//   const startDate = useSelector((state) => state.operationHome.tabStartDate);
//   const endDate = useSelector((state) => state.operationHome.tabEndDate);
//   const requestProcessed = useSelector(
//     (state) => state.operationHome.requestProcessed
//   );
//   const requestError = useSelector((state) => state.operationHome.requestError);

//   const [show, setShow] = useState(false);
//   const [draggable, setDraggable] = useState(true);
//   const [fullscreen, setFullscreen] = useState(false);
//   const [position, setPosition] = useState({ x: 0, y: 0 });
//   const [isNotesOpen, setIsNotesOpen] = useState(true);
//   const [newMessage, setNewMessage] = useState("");
//   const [isUpdated, setIsUpdated] = useState(false);
//   const [newNotes, setNewNotes] = useState([]);
//   const [statusColour, setStatusColour] = useState("#FEDAD9");
//   const [payloadData, setPayloadData] = useState({
//     status: "",
//     assigneeId: "",
//     assigneeName: "",
//   });

//   const [downloadVisible, setDownloadVisible] = useState(false); // State to toggle download component

//   const handleDownload = () => {
//     setDownloadVisible(true); // Show the Download component when clicked
//   };

//   const [workScreenData, setWorkScreenData] = useState({
//     issueId: "",
//     callId: "",
//     callCategory: "",
//     customerName: " ",
//     agentName: " ",
//     status: "",
//     assigneeName: "",
//     assigneeId: "",
//     notes: [],
//     history: [],
//     changeSubscription: "",
//     assignee: [],
//   });
//   const [chats, setChats] = useState([]);
//   const [status, setStatus] = useState([
//     {
//       value: "Open",
//     },
//     {
//       value: "In-Progress",
//     },
//     {
//       value: "Closed",
//     },
//   ]);
//   let color = "red";
//   useEffect(() => {
//     if (requestProcessed && !requestError && isUpdated) {
//       handleClose();
//       refreshOperationHome();
//       setIsUpdated(false);
//     }
//   }, [requestProcessed, requestError, setIsUpdated]);

//   // useEffect(()=>{
//   //   setChats(data[0].note);
//   // },[data]);
//   useEffect(() => {
//     if (data && isNotesOpen) {
//       setChats(data.notes);
//       setWorkScreenData({
//         issueId: data.issueId,
//         callId: data.callId,
//         callCategory: data.callCategory,
//         customerName: data.customerName,
//         agentName: data.agentName,
//         status: data.status,
//         assigneeName: data.assigneeName,
//         assigneeId: data.assigneeId,
//         notes: data.notes || [],
//         history: data.history || [],
//         changeSubscription: data.changeSubscription,
//         assignee: data.assignee || [],
//       });
//       if (data.status == "Open") {
//         setStatusColour("#FFEFE7");
//       } else if (data.status == "In-Progress") {
//         setStatusColour("#E8F0FB");
//       } else if (data.status == "Closed") {
//         setStatusColour("#FDEBF9");
//       }
//       setPayloadData({
//         status: data.status,
//         assigneeId: data.assigneeId,
//         assigneeName: data.assigneeName,
//       });
//     }
//   }, [data, isNotesOpen]);

//   const LoginUserData = useSelector((state) => {
//     return state.login;
//   });

//   const handleSendMessage = () => {
//     const date = new Date();
//     const formattedDate = date.toLocaleDateString("en-GB", {
//       day: "numeric",
//       month: "short",
//       year: "numeric",
//     });
//     const newChat = {
//       id: 1,
//       username: "Me",
//       message: newMessage,
//       date: formattedDate,
//       avatar:
//         "https://th.bing.com/th/id/OIP.WpnGIPj1DKAGo-CP64znTwHaHa?w=199&h=198&c=7&r=0&o=5&pid=1.7",
//     };

//     var payload = {
//       customerId: callId, //callId is memberId
//       issueId: data.issueId,
//       notes: newMessage,
//       noteAddedBy: `${LoginUserData.login.data.data[0].FirstName} ${LoginUserData.login.data.data[0].LastName}`,
//       noteAddedUserId: LoginUserData.login.data.data[0].AdminID,
//     };
//     console.log(payload);
//     // setWorkScreenData({
//     //   ...workScreenData,
//     //   notes: [
//     //     ...(workScreenData.notes || []),  // Ensure `notes` is an array, default to empty array if undefined
//     //     {
//     //       "agentName": `${LoginUserData.login.data.data[0].FirstName} ${LoginUserData.login.data.data[0].LastName}`,
//     //       "agentId": LoginUserData.login.data.data[0].AdminID,
//     //       "createdOn": new Date(),  // Correct usage of new Date
//     //       "notes": newMessage
//     //     }
//     //   ]
//     // });

//     // data.notes.push(  );
//     dispatch(postWorkScreenData(payload, "callId"));

//     // setNewNotes([newChat, ...newNotes]);
//     // setChats([newChat, ...chats]);
//     setNewMessage("");
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter") {
//       // handleSendMessage(); // do not save on enter
//     }
//   };

//   const handleClose = () => {
//     setShow(false);
//     setFullscreen(false);
//     setDraggable(true);
//     // refreshOperationHome();
//   };
//   // const handleShow = () => setShow(true);

//   const handleShow = () => {
//     setFullscreen(false);
//     setDraggable(true);
//     setShow(true);
//     dispatch(fetchWorkScreenData(callId));
//     dispatch(getMemberId(callId));
//   };

//   // const handleMinimize = () => {
//   //   setFullscreen(false);
//   //   setDraggable(true);
//   // };
//   const handleMinimize = () => {
//     if (fullscreen) {
//       // If currently fullscreen, restore to normal
//       setFullscreen(false);
//       setDraggable(true);
//     } else {
//       // If already in normal state, close the modal
//       setDraggable(false);
//       setShow(false);
//       // refreshOperationHome();
//     }
//   };

//   const handleMaximize = () => {
//     setFullscreen(true);
//     setDraggable(false);
//   };

//   const handleDrag = (e, data) => {
//     setPosition({ x: data.x, y: data.y });
//   };

//   const refreshOperationHome = () => {
//     if (
//       (searchFields && Object.keys(searchFields)?.length !== 0) ||
//       pageSize !== 5 ||
//       currentPage !== 1
//     )
//       dispatch(
//         fetchFilteredTableDataInit({
//           pageSize,
//           currentPage,
//           activeTab,
//           startDate,
//           endDate,
//           searchFields,
//         })
//       );
//     else
//       dispatch(getOperationDataInit({ name: activeTab, startDate, endDate }));
//   };

//   const postData = async () => {
//     var selectedAssignee = data.assignee.find(
//       (obj) => String(obj.assigneeId) === String(payloadData.assigneeId)
//     );

//     var payload = {
//       customerId: callId, // callId is memberId
//       issueId: data.issueId,
//       status: payloadData.status,
//       // assigneeName: payloadData.assigneeId!==""? data.assignee.filter((obj) => { return obj.assigneeId == payloadData.assigneeId })[0].assigneeName:"",
//       assigneeName: selectedAssignee ? selectedAssignee.assigneeName : "", // Use the selectedAssignee safely
//       assigneeId: Number(payloadData.assigneeId),
//       callId: data.callId,
//     };

//     console.log(payload);

//     try {
//       // Dispatch the action and await the result
//       handleSendMessage();
//       dispatch(postWorkScreenData(payload));

//       // Close the modal after saving data
//       // handleClose();

//       setIsUpdated(true);

//       // Refetch the data for the current callId to reload only the data
//       // dispatch(fetchWorkScreenData(callId));
//     } catch (error) {
//       console.error("Error saving data:", error);
//     }
//   };

//   const handleNavigate = () => {
//     if (data) {
//       const memberId = data.memberId?.replace(/\s+/g, "") || "defaultId";
//       console.log("Navigating to memberId:", memberId);
//       navigate(`/detailsPage/${memberId}`);
//     }
//   };
//   // const handleChange = (event) => {
//   //   let value = event.target.value;
//   //   let name = event.target.name;
//   //   console.log(value, name);
//   // }
//   const handleChange = (event) => {
//     const { name, value } = event.target; // Destructure the name and value correctly
//     setPayloadData({
//       ...payloadData,
//       [name]: value, // Update the corresponding field in payload dynamically
//     });
//     if (value == "Open") {
//       setStatusColour("#FFEFE7");
//     } else if (value == "In-Progress") {
//       setStatusColour("#E8F0FB");
//     } else if (value == "Closed") {
//       setStatusColour("#FDEBF9");
//     }
//   };

//   return (
//     <div className="WS-workscreen">
//       <Button className="WS-link-btn" onClick={handleShow}>
//         {value}
//       </Button>

//       <Modal
//         show={show}
//         backdrop="static"
//         size="lg"
//         onHide={handleClose}
//         className="WS-modal"
//         fullscreen={fullscreen}
//       >
//         <Draggable
//           disabled={!draggable}
//           position={fullscreen ? { x: 0, y: 0 } : position}
//           onDrag={handleDrag}
//         >
//           <Modal.Body className="WS-modal-body">
//             <div className="WS-ribbon">
//               <div className="WS-icon-button" onClick={handleMinimize}>
//                 <FaMinus />
//               </div>
//               <div className="WS-icon-button" onClick={handleMaximize}>
//                 <CopyIcon />
//               </div>
//               <div className="WS-icon-button" onClick={handleClose}>
//                 <CloseIcon />
//               </div>
//             </div>
//             <div className="WS-issue-header">
//               <img src={IssueIcon} className="WS-issue-icon" />
//               <span># Issue - {workScreenData && workScreenData.issueId}</span>
//             </div>
//             <Container>
//               <Row>
//                 <Col xs={8} md={8}>
//                   <Card className="WS-left-card">
//                     <div className="WS-collapse-icon2"></div>
//                     <div className="WS-issue-details">
//                       <div>
//                         <span className="WS-detail-label1">
//                           Call Category:{" "}
//                         </span>

//                         <span className="WS-detail-text" style={{border:"2px solid #E1F6FF", padding:"3px", borderRadius:"4.83px", background:"#E1F6FF", marginLeft:"6px"}}>
//                           {workScreenData && workScreenData.callCategory}
//                         </span>
//                       </div>
//                       <div>
//                         <span className="WS-detail-label">
//                           Customer's Name:{" "}
//                         </span>
//                         <span className="WS-detail-text" style={{fontWeight: "bold"}}>
//                           {workScreenData && workScreenData.customerName}
//                         </span>
//                       </div>
//                       <div>
//                         <span className="WS-detail-label">Agent's Name: </span>
//                         <span className="WS-detail-text" style={{fontWeight: "bold"}}>
//                           {workScreenData?.agentName || ""}
//                         </span>
//                       </div>
//                       <div>
//                         <div className="WS-detail-label2">
//                           Change in Subscription
//                         </div>
//                         <p className="WS-detail-text1">
//                           {workScreenData && workScreenData.changeSubscription}
//                         </p>
//                       </div>
//                       <div
//                         className="CaseDetails"
//                         onClick={() =>
//                           navigate(`/detailsPage/${callId.replace(/\s+/g, "")}`)
//                         }
//                       >
//                         <GoLink /> Case Details
//                       </div>
//                       <hr/>
//                       <div>
//                         <div className="WS-tabulation">
//                           <button
//                             className={`WS-tab-btn ${
//                               isNotesOpen ? "selected" : ""
//                             }`}
//                             onClick={() => {
//                               setIsNotesOpen(true);
//                               setChats(workScreenData.notes);
//                             }}
//                           >
//                             Notes
//                           </button>
//                           <button
//                             className={`WS-tab-btn ${
//                               isNotesOpen ? "" : "selected"
//                             }`}
//                             onClick={() => {
//                               setIsNotesOpen(false);
//                               setChats(workScreenData.history);
//                             }}
//                           >
//                             History
//                           </button>
//                         </div>
//                         <HistorySection sizeLg={!isNotesOpen} chats={chats} />
//                         {isNotesOpen && (
//                           <InputGroup className="mt-3">
//                             <Form.Control
//                               type="text"
//                               placeholder="Reply or post an Update"
//                               value={newMessage}
//                               onChange={(e) => setNewMessage(e.target.value)}
//                               onKeyDown={handleKeyDown}
//                               className="custom-placeholder"
//                             />
//                             {/* <img src={WorkBtnImg} onClick={handleSendMessage} /> */}

//                             {/* <Button onClick={handleSendMessage} variant="primary">
//                             Send
//                           </Button> */}
//                           </InputGroup>
//                         )}
//                       </div>
//                     </div>
//                   </Card>
//                 </Col>
//                 <Col xs={4} md={4}>
//                   <Card className="WS-right-card">
//                     <button
//                       className="WS-download-btn"
//                       onClick={handleDownload}
//                     >
//                       <img src={DownloadIcon} alt="Download All" />
//                       Download All
//                     </button>

//                     <div className="WS-select-field">
//                       <label className="WS-select-label">Status:</label>
//                       <div className="custom-select"
//                         style={{
//                           // border: "2px solid #EBEBEB",
//                           // width: "120px",
//                           // height: "38px",
//                           // padding: "3px",
//                           // borderRadius: "5px",
//                           border: "2px solid #EBEBEB",
//                           width: "115px",
//                           height: "38px",
//                           padding: "3px",
//                           borderRadius: "5px",
//                         }}
//                       >
//                         <select
//                           value={payloadData.status}
//                           onChange={handleChange}
//                           name="status"
//                           style={{
//                             // backgroundColor: statusColour,
//                             // borderRadius: "10px",
//                             // width: "80px",
//                             // border: "none",
//                             // outline: "none",
//                             // textAlign: "center"
//                             border: "2px solid #EBEBEB",
//                             backgroundColor: statusColour,
//                             borderRadius: "10px",
//                             width: "90px",
//                             border: "none",
//                             outline: "none",
//                             height: "28px",
//                           }}
//                         >
//                           {status?.map((obj) => {
//                             return (
//                               // <option value="open">
//                               //   <span className="WS-tag tag-open">
//                               //     {obj.value}
//                               //   </span>
//                               // </option>
//                               <option
//                                 key={obj.value}
//                                 value={obj.value}
//                                 style={{ backgroundColor: "white" }}
//                               >
//                                 {" "}
//                                 {/* Use obj.value as the option value */}
//                                 <span className="WS-tag tag-open">
//                                   {obj.value}
//                                 </span>
//                               </option>
//                             );
//                           })}
//                         </select>
//                       </div>
//                     </div>
//                     <div className="WS-select-field">
//                       <label className="WS-select-label">Assignee:</label>
//                       <div className="custom-select">
//                       <select
//                         value={payloadData.assigneeId}
//                         onChange={handleChange}
//                         name="assigneeId"
//                         style={{
//                           border: "2px solid #EBEBEB",
//                           width: "136px",
//                           height: "38px",
//                           padding: "2px",
//                           borderRadius: "5px",
//                         }}
//                       >
//                         {workScreenData?.assignee &&
//                           workScreenData?.assignee?.map((obj, index) => {
//                             return (
//                               <option
//                                 key={index}
//                                 // key={obj.assigneeId}
//                                 value={obj.assigneeId}
//                               >
//                                 <span style={{ color: "#D8D8D8" }}>
//                                   &#9899; {/* Black Circle */}
//                                 </span>
//                                 {obj.assigneeName}
//                               </option>
//                             );
//                           })}
//                       </select>
//                       </div>
//                     </div>
//                   </Card>
//                 </Col>
//               </Row>
//             </Container>
//             <Button className="WS-save-btn" type="button" onClick={postData}>
//               Save
//             </Button>
//             {downloadVisible && (
//               <Download
//                 data={workScreenData}
//                 onDownloadComplete={() => setDownloadVisible(false)}
//               />
//             )}
//           </Modal.Body>
//         </Draggable>
//       </Modal>
//     </div>
//   );
// }

// export default WorkScreen;
// import { useState, useEffect } from "react";
// import "./WorkScreen.css";
// import Download from "./Download/Download";
// import {
//   Card,
//   Col,
//   Container,
//   Row,
//   Button,
//   Modal,
//   InputGroup,
//   Form,
// } from "react-bootstrap";
// import Draggable from "react-draggable";
// import { FaMinus } from "react-icons/fa";
// import { GoLink } from "react-icons/go";
// import { ReactComponent as CloseIcon } from "../../../assets/images/cross-icon.svg";
// import { ReactComponent as CopyIcon } from "../../../assets/images/copy-icon.svg";
// import IssueIcon from "../../../assets/images/issue-icon.png";
// import DownloadIcon from "../../../assets/images/download-icon.png";
// import HistorySection from "./HistorySection";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   fetchWorkScreenData,
//   postWorkScreenData,
//   getMemberId,
//   fetchFilteredTableDataInit,
//   getOperationDataInit,
// } from "../../../redux/slices/operationHomeSlice";
// import { useNavigate } from "react-router-dom";
// import Spinner from "../../../common/components/Spinner/Spinner";
// import WorkBtnImg from "../../../assets/images/work-send-btn.png";
// import Ellipse1 from "../../../assets/images/Ellipse 1.png";
// // import Downloadall from "../WorkScreen/DownloadAll";

// function WorkScreen({ value, callId }) {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const data = useSelector((state) => state.operationHome.workScreenData);
//   console.log(data);
//   console.log(data);
//   const isWorkScreenLoading = useSelector(
//     (state) => state.operationHome.isWorkScreenLoading
//   );
//   const currentPage = useSelector(
//     (state) => state.operationHome.table.currentPage
//   );
//   const pageSize = useSelector((state) => state.operationHome.table.pageSize);
//   const searchFields = useSelector((state) => state.operationHome.searchFields);
//   const activeTab = useSelector((state) => state.operationHome.activeTab);
//   const startDate = useSelector((state) => state.operationHome.tabStartDate);
//   const endDate = useSelector((state) => state.operationHome.tabEndDate);
//   const requestProcessed = useSelector(
//     (state) => state.operationHome.requestProcessed
//   );
//   const requestError = useSelector((state) => state.operationHome.requestError);

//   const [show, setShow] = useState(false);
//   const [draggable, setDraggable] = useState(true);
//   const [fullscreen, setFullscreen] = useState(false);
//   const [position, setPosition] = useState({ x: 0, y: 0 });
//   const [isNotesOpen, setIsNotesOpen] = useState(true);
//   const [newMessage, setNewMessage] = useState("");
//   const [isUpdated, setIsUpdated] = useState(false);
//   const [newNotes, setNewNotes] = useState([]);
//   const [statusColour, setStatusColour] = useState("#FEDAD9");
//   const [payloadData, setPayloadData] = useState({
//     status: "",
//     assigneeId: "",
//     assigneeName: "",
//   });

//   const [downloadVisible, setDownloadVisible] = useState(false); // State to toggle download component

//   const handleDownload = () => {
//     setDownloadVisible(true); // Show the Download component when clicked
//   };

//   const [workScreenData, setWorkScreenData] = useState({
//     issueId: "",
//     callId: "",
//     callCategory: "",
//     customerName: " ",
//     agentName: " ",
//     status: "",
//     assigneeName: "",
//     assigneeId: "",
//     notes: [],
//     history: [],
//     changeSubscription: "",
//     assignee: [],
//   });
//   const [chats, setChats] = useState([]);
//   const [status, setStatus] = useState([
//     {
//       value: "Open",
//     },
//     {
//       value: "In-Progress",
//     },
//     {
//       value: "Closed",
//     },
//   ]);
//   let color = "red";
//   useEffect(() => {
//     if (requestProcessed && !requestError && isUpdated) {
//       handleClose();
//       refreshOperationHome();
//       setIsUpdated(false);
//     }
//   }, [requestProcessed, requestError, setIsUpdated]);

//   // useEffect(()=>{
//   //   setChats(data[0].note);
//   // },[data]);
//   useEffect(() => {
//     if (data && isNotesOpen) {
//       setChats(data.notes);
//       setWorkScreenData({
//         issueId: data.issueId,
//         callId: data.callId,
//         callCategory: data.callCategory,
//         customerName: data.customerName,
//         agentName: data.agentName,
//         status: data.status,
//         assigneeName: data.assigneeName,
//         assigneeId: data.assigneeId,
//         notes: data.notes || [],
//         history: data.history || [],
//         changeSubscription: data.changeSubscription,
//         assignee: data.assignee || [],
//       });
//       if (data.status == "Open") {
//         setStatusColour("#FFEFE7");
//       } else if (data.status == "In-Progress") {
//         setStatusColour("#E8F0FB");
//       } else if (data.status == "Closed") {
//         setStatusColour("#FDEBF9");
//       }
//       setPayloadData({
//         status: data.status,
//         assigneeId: data.assigneeId,
//         assigneeName: data.assigneeName,
//       });
//     }
//   }, [data, isNotesOpen]);

//   const LoginUserData = useSelector((state) => {
//     return state.login;
//   });

//   const handleSendMessage = () => {
//     const date = new Date();
//     const formattedDate = date.toLocaleDateString("en-GB", {
//       day: "numeric",
//       month: "short",
//       year: "numeric",
//     });
//     const newChat = {
//       id: 1,
//       username: "Me",
//       message: newMessage,
//       date: formattedDate,
//       avatar:
//         "https://th.bing.com/th/id/OIP.WpnGIPj1DKAGo-CP64znTwHaHa?w=199&h=198&c=7&r=0&o=5&pid=1.7",
//     };

//     var payload = {
//       customerId: callId, //callId is memberId
//       issueId: data.issueId,
//       notes: newMessage,
//       noteAddedBy: `${LoginUserData.login.data.data[0].FirstName} ${LoginUserData.login.data.data[0].LastName}`,
//       noteAddedUserId: LoginUserData.login.data.data[0].AdminID,
//     };
//     console.log(payload);
//     // setWorkScreenData({
//     //   ...workScreenData,
//     //   notes: [
//     //     ...(workScreenData.notes || []),  // Ensure `notes` is an array, default to empty array if undefined
//     //     {
//     //       "agentName": `${LoginUserData.login.data.data[0].FirstName} ${LoginUserData.login.data.data[0].LastName}`,
//     //       "agentId": LoginUserData.login.data.data[0].AdminID,
//     //       "createdOn": new Date(),  // Correct usage of new Date
//     //       "notes": newMessage
//     //     }
//     //   ]
//     // });

//     // data.notes.push(  );
//     dispatch(postWorkScreenData(payload, "callId"));

//     // setNewNotes([newChat, ...newNotes]);
//     // setChats([newChat, ...chats]);
//     setNewMessage("");
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter") {
//       // handleSendMessage(); // do not save on enter
//     }
//   };

//   const handleClose = () => {
//     setShow(false);
//     setFullscreen(false);
//     setDraggable(true);
//     // refreshOperationHome();
//   };
//   // const handleShow = () => setShow(true);

//   const handleShow = () => {
//     setFullscreen(false);
//     setDraggable(true);
//     setShow(true);
//     dispatch(fetchWorkScreenData(callId));
//     dispatch(getMemberId(callId));
//   };

//   // const handleMinimize = () => {
//   //   setFullscreen(false);
//   //   setDraggable(true);
//   // };
//   const handleMinimize = () => {
//     if (fullscreen) {
//       // If currently fullscreen, restore to normal
//       setFullscreen(false);
//       setDraggable(true);
//     } else {
//       // If already in normal state, close the modal
//       setDraggable(false);
//       setShow(false);
//       // refreshOperationHome();
//     }
//   };

//   const handleMaximize = () => {
//     setFullscreen(true);
//     setDraggable(false);
//   };

//   const handleDrag = (e, data) => {
//     setPosition({ x: data.x, y: data.y });
//   };

//   const refreshOperationHome = () => {
//     if (
//       (searchFields && Object.keys(searchFields)?.length !== 0) ||
//       pageSize !== 5 ||
//       currentPage !== 1
//     )
//       dispatch(
//         fetchFilteredTableDataInit({
//           pageSize,
//           currentPage,
//           activeTab,
//           startDate,
//           endDate,
//           searchFields,
//         })
//       );
//     else
//       dispatch(getOperationDataInit({ name: activeTab, startDate, endDate }));
//   };

//   const postData = async () => {
//     var selectedAssignee = data.assignee.find(
//       (obj) => String(obj.assigneeId) === String(payloadData.assigneeId)
//     );

//     var payload = {
//       customerId: callId, // callId is memberId
//       issueId: data.issueId,
//       status: payloadData.status,
//       // assigneeName: payloadData.assigneeId!==""? data.assignee.filter((obj) => { return obj.assigneeId == payloadData.assigneeId })[0].assigneeName:"",
//       assigneeName: selectedAssignee ? selectedAssignee.assigneeName : "", // Use the selectedAssignee safely
//       assigneeId: Number(payloadData.assigneeId),
//       callId: data.callId,
//     };

//     console.log(payload);

//     try {
//       // Dispatch the action and await the result
//       handleSendMessage();
//       dispatch(postWorkScreenData(payload));

//       // Close the modal after saving data
//       // handleClose();

//       setIsUpdated(true);

//       // Refetch the data for the current callId to reload only the data
//       // dispatch(fetchWorkScreenData(callId));
//     } catch (error) {
//       console.error("Error saving data:", error);
//     }
//   };

//   const handleNavigate = () => {
//     if (data) {
//       const memberId = data.memberId?.replace(/\s+/g, "") || "defaultId";
//       console.log("Navigating to memberId:", memberId);
//       navigate(`/detailsPage/${memberId}`);
//     }
//   };
//   // const handleChange = (event) => {
//   //   let value = event.target.value;
//   //   let name = event.target.name;
//   //   console.log(value, name);
//   // }
//   const handleChange = (event) => {
//     const { name, value } = event.target; // Destructure the name and value correctly
//     setPayloadData({
//       ...payloadData,
//       [name]: value, // Update the corresponding field in payload dynamically
//     });
//     if (value == "Open") {
//       setStatusColour("#FFEFE7");
//     } else if (value == "In-Progress") {
//       setStatusColour("#E8F0FB");
//     } else if (value == "Closed") {
//       setStatusColour("#FDEBF9");
//     }
//   };

//   return (
//     <div className="WS-workscreen">
//       <Button className="WS-link-btn" onClick={handleShow}>
//         {value}
//       </Button>

//       <Modal
//         show={show}
//         backdrop="static"
//         size="lg"
//         onHide={handleClose}
//         className="WS-modal"
//         fullscreen={fullscreen}
//       >
//         <Draggable
//           disabled={!draggable}
//           position={fullscreen ? { x: 0, y: 0 } : position}
//           onDrag={handleDrag}
//         >
//           <Modal.Body className="WS-modal-body">
//             <div className="WS-ribbon">
//               <div className="WS-icon-button" onClick={handleMinimize}>
//                 <FaMinus />
//               </div>
//               <div className="WS-icon-button" onClick={handleMaximize}>
//                 <CopyIcon />
//               </div>
//               <div className="WS-icon-button" onClick={handleClose}>
//                 <CloseIcon />
//               </div>
//             </div>
//             <div className="WS-issue-header">
//               <img src={IssueIcon} className="WS-issue-icon" />
//               <span># Issue - {workScreenData && workScreenData.issueId}</span>
//             </div>
//             <Container>
//               <Row>
//                 <Col xs={8} md={8}>
//                   <Card className="WS-left-card">
//                     <div className="WS-collapse-icon2"></div>
//                     <div className="WS-issue-details">
//                       <div>
//                         <span className="WS-detail-label1">
//                           Call Category:{" "}
//                         </span>

//                         <span className="WS-detail-text" style={{border:"2px solid #E1F6FF", padding:"3px", borderRadius:"4.83px", background:"#E1F6FF", marginLeft:"6px"}}>
//                           {workScreenData && workScreenData.callCategory}
//                         </span>
//                       </div>
//                       <div>
//                         <span className="WS-detail-label">
//                           Customer's Name:{" "}
//                         </span>
//                         <span className="WS-detail-text" style={{fontWeight: "bold"}}>
//                           {workScreenData && workScreenData.customerName}
//                         </span>
//                       </div>
//                       <div>
//                         <span className="WS-detail-label">Agent's Name: </span>
//                         <span className="WS-detail-text" style={{fontWeight: "bold"}}>
//                           {workScreenData?.agentName || ""}
//                         </span>
//                       </div>
//                       <div>
//                         <div className="WS-detail-label2">
//                           Change in Subscription
//                         </div>
//                         <p className="WS-detail-text1">
//                           {workScreenData && workScreenData.changeSubscription}
//                         </p>
//                       </div>
//                       <div
//                         className="CaseDetails"
//                         onClick={() =>
//                           navigate(`/detailsPage/${callId.replace(/\s+/g, "")}`)
//                         }
//                       >
//                         <GoLink /> Case Details
//                       </div>
//                       <hr/>
//                       <div>
//                         <div className="WS-tabulation">
//                           <button
//                             className={`WS-tab-btn ${
//                               isNotesOpen ? "selected" : ""
//                             }`}
//                             onClick={() => {
//                               setIsNotesOpen(true);
//                               setChats(workScreenData.notes);
//                             }}
//                           >
//                             Notes
//                           </button>
//                           <button
//                             className={`WS-tab-btn ${
//                               isNotesOpen ? "" : "selected"
//                             }`}
//                             onClick={() => {
//                               setIsNotesOpen(false);
//                               setChats(workScreenData.history);
//                             }}
//                           >
//                             History
//                           </button>
//                         </div>
//                         <HistorySection sizeLg={!isNotesOpen} chats={chats} />
//                         {isNotesOpen && (
//                           <InputGroup className="mt-3">
//                             <Form.Control
//                               type="text"
//                               placeholder="Reply or post an Update"
//                               value={newMessage}
//                               onChange={(e) => setNewMessage(e.target.value)}
//                               onKeyDown={handleKeyDown}
//                               className="custom-placeholder"
//                             />
//                             {/* <img src={WorkBtnImg} onClick={handleSendMessage} /> */}

//                             {/* <Button onClick={handleSendMessage} variant="primary">
//                             Send
//                           </Button> */}
//                           </InputGroup>
//                         )}
//                       </div>
//                     </div>
//                   </Card>
//                 </Col>
//                 <Col xs={4} md={4}>
//                   <Card className="WS-right-card">
//                     <button
//                       className="WS-download-btn"
//                       onClick={handleDownload}
//                     >
//                       <img src={DownloadIcon} alt="Download All" />
//                       Download All
//                     </button>

//                     <div className="WS-select-field">
//                       <label className="WS-select-label">Status:</label>
//                       <div className="custom-select"
//                         style={{
//                           // border: "2px solid #EBEBEB",
//                           // width: "120px",
//                           // height: "38px",
//                           // padding: "3px",
//                           // borderRadius: "5px",
//                           border: "2px solid #EBEBEB",
//                           width: "115px",
//                           height: "38px",
//                           padding: "3px",
//                           borderRadius: "5px",
//                         }}
//                       >
//                         <select
//                           value={payloadData.status}
//                           onChange={handleChange}
//                           name="status"
//                           style={{
//                             // backgroundColor: statusColour,
//                             // borderRadius: "10px",
//                             // width: "80px",
//                             // border: "none",
//                             // outline: "none",
//                             // textAlign: "center"
//                             border: "2px solid #EBEBEB",
//                             backgroundColor: statusColour,
//                             borderRadius: "10px",
//                             width: "90px",
//                             border: "none",
//                             outline: "none",
//                             height: "28px",
//                           }}
//                         >
//                           {status?.map((obj) => {
//                             return (
//                               // <option value="open">
//                               //   <span className="WS-tag tag-open">
//                               //     {obj.value}
//                               //   </span>
//                               // </option>
//                               <option
//                                 key={obj.value}
//                                 value={obj.value}
//                                 style={{ backgroundColor: "white" }}
//                               >
//                                 {" "}
//                                 {/* Use obj.value as the option value */}
//                                 <span className="WS-tag tag-open">
//                                   {obj.value}
//                                 </span>
//                               </option>
//                             );
//                           })}
//                         </select>
//                       </div>
//                     </div>
//                     <div className="WS-select-field">
//                       <label className="WS-select-label">Assignee:</label>
//                       <div className="custom-select">
//                       <select
//                         value={payloadData.assigneeId}
//                         onChange={handleChange}
//                         name="assigneeId"
//                         style={{
//                           border: "2px solid #EBEBEB",
//                           width: "136px",
//                           height: "38px",
//                           padding: "2px",
//                           borderRadius: "5px",
//                         }}
//                       >
//                         {workScreenData?.assignee &&
//                           workScreenData?.assignee?.map((obj, index) => {
//                             return (
//                               <option
//                                 key={index}
//                                 // key={obj.assigneeId}
//                                 value={obj.assigneeId}
//                               >
//                                 <span style={{ color: "#D8D8D8" }}>
//                                   &#9899; {/* Black Circle */}
//                                 </span>
//                                 {obj.assigneeName}
//                               </option>
//                             );
//                           })}
//                       </select>
//                       </div>
//                     </div>
//                   </Card>
//                 </Col>
//               </Row>
//             </Container>
//             <Button className="WS-save-btn" type="button" onClick={postData}>
//               Save
//             </Button>
//             {downloadVisible && (
//               <Download
//                 data={workScreenData}
//                 onDownloadComplete={() => setDownloadVisible(false)}
//               />
//             )}
//           </Modal.Body>
//         </Draggable>
//       </Modal>
//     </div>
//   );
// }

// export default WorkScreen;

// WorkScreen.jsx
import { useState, useEffect } from "react";
import "./WorkScreen.css";
import Download from "./Download/Download";
import {
  Card,
  Col,
  Container,
  Row,
  Button,
  Modal,
  InputGroup,
  Form,
} from "react-bootstrap";
import Draggable from "react-draggable";
import { FaMinus } from "react-icons/fa";
import { GoLink } from "react-icons/go";
import { ReactComponent as CloseIcon } from "../../../assets/images/cross-icon.svg";
import { ReactComponent as CopyIcon } from "../../../assets/images/copy-icon.svg";
import IssueIcon from "../../../assets/images/issue-icon.png";
import DownloadIcon from "../../../assets/images/download-icon.png";
import HistorySection from "./HistorySection";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchWorkScreenData,
  postWorkScreenData,
  getMemberId,
  fetchFilteredTableDataInit,
  getOperationDataInit,
} from "../../../redux/slices/operationHomeSlice";
import { useNavigate } from "react-router-dom";
import Spinner from "../../../common/components/Spinner/Spinner";
import PropTypes from "prop-types";
import UIConfig from "../../../common/constants/UIConfig";

function WorkScreen({ value, callId, disabled }) {
  // Accept the disabled prop
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const data = useSelector((state) => state.operationHome.workScreenData);
  console.log(data);
  const isWorkScreenLoading = useSelector(
    (state) => state.operationHome.isWorkScreenLoading,
  );
  const currentPage = useSelector(
    (state) => state.operationHome.table.currentPage,
  );
  const pageSize = useSelector((state) => state.operationHome.table.pageSize);
  const searchFields = useSelector((state) => state.operationHome.searchFields);
  const activeTab = useSelector((state) => state.operationHome.activeTab);
  const startDate = useSelector((state) => state.operationHome.tabStartDate);
  const endDate = useSelector((state) => state.operationHome.tabEndDate);
  const requestProcessed = useSelector(
    (state) => state.operationHome.requestProcessed,
  );
  const requestError = useSelector((state) => state.operationHome.requestError);

  const [show, setShow] = useState(false);
  const [draggable, setDraggable] = useState(true);
  const [fullscreen, setFullscreen] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isNotesOpen, setIsNotesOpen] = useState(true);
  const [newMessage, setNewMessage] = useState("");
  const [isUpdated, setIsUpdated] = useState(false);
  const [newNotes, setNewNotes] = useState([]);
  const [statusColour, setStatusColour] = useState("#FEDAD9");
  const [payloadData, setPayloadData] = useState({
    status: "",
    assigneeId: "",
    assigneeName: "",
  });

  const [downloadVisible, setDownloadVisible] = useState(false); // State to toggle download component

  const handleDownload = () => {
    if (!disabled) {
      // Prevent download if disabled
      setDownloadVisible(true); // Show the Download component when clicked
    }
  };

  const [workScreenData, setWorkScreenData] = useState({
    issueId: "",
    callId: "",
    callCategory: "",
    customerName: " ",
    agentName: " ",
    status: "",
    assigneeName: "",
    assigneeId: "",
    notes: [],
    history: [],
    changeSubscription: "",
    assignee: [],
  });
  const [chats, setChats] = useState([]);
  const [statusOptions, setStatusOptions] = useState([
    {
      text: "Open",
      value: "Yes",
    },
    {
      text: "In-Progress",
      value: "In-Progress",
    },
    {
      text: "Closed",
      value: "Closed",
    },
  ]);

  useEffect(() => {
    if (requestProcessed && !requestError && isUpdated) {
      // handleClose();
      // refreshOper
      // ationHome();
      setIsUpdated(false);
    }
  }, [requestProcessed, requestError, isUpdated]);

  useEffect(() => {
    if (data && isNotesOpen) {
      setChats(data.notes);
      setWorkScreenData({
        issueId: data.issueId,
        callId: data.callId,
        callCategory: data.callCategory,
        customerName: data.customerName,
        agentName: data.agentName,
        status: data.status,
        assigneeName: data.assigneeName,
        assigneeId: data.assigneeId,
        notes: data.notes || [],
        history: data.history || [],
        changeSubscription: data.changeSubscription,
        assignee: data.assignee || [],
      });
      if (data.status === "Open") {
        setStatusColour("#FEDAD9");
      } else if (data.status === "In-Progress") {
        setStatusColour("#E8F0FB");
      } else if (data.status === "Closed") {
        setStatusColour("#FDEBF9");
      }
      setPayloadData({
        status: data.status,
        assigneeId: data.assigneeId,
        assigneeName: data.assigneeName,
      });
    }
  }, [data, isNotesOpen]);

  const LoginUserData = useSelector((state) => state.login);

  const handleSendMessage = () => {
    const date = new Date();
    const formattedDate = date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
      timeZone: UIConfig.branding.timeZone || "America/New_York",
    });
    const newChat = {
      id: 1,
      username: "Me",
      message: newMessage,
      date: formattedDate,
      avatar:
        "https://th.bing.com/th/id/OIP.WpnGIPj1DKAGo-CP64znTwHaHa?w=199&h=198&c=7&r=0&o=5&pid=1.7",
    };

    var payload = {
      customerId: callId, //callId is memberId
      issueId: data.issueId,
      notes: newMessage,
      noteAddedBy: `${LoginUserData.login.data.data[0].FirstName} ${LoginUserData.login.data.data[0].LastName}`,
      noteAddedUserId: LoginUserData.login.data.data[0].AdminID,
    };
    console.log("Sending message payload:", payload);

    dispatch(postWorkScreenData(payload, "callId"));

    setNewMessage("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      // handleSendMessage(); // do not save on enter
    }
  };

  const handleClose = () => {
    setShow(false);
    setFullscreen(false);
    setDraggable(true);
    refreshOperationHome();
  };

  const handleShow = () => {
    if (disabled) return; // Prevent opening if disabled
    setFullscreen(false);
    setDraggable(true);
    setShow(true);
    dispatch(fetchWorkScreenData(callId));
    dispatch(getMemberId(callId));
  };

  const handleMinimize = () => {
    if (fullscreen) {
      // If currently fullscreen, restore to normal
      setFullscreen(false);
      setDraggable(true);
    } else {
      // If already in normal state, close the modal
      setDraggable(false);
      setShow(false);
      // refreshOperationHome();
    }
  };

  const handleMaximize = () => {
    setFullscreen(true);
    setDraggable(false);
  };

  const handleDrag = (e, data) => {
    setPosition({ x: data.x, y: data.y });
  };

  const refreshOperationHome = () => {
    if (
      (searchFields && Object.keys(searchFields)?.length !== 0) ||
      pageSize !== 5 ||
      currentPage !== 1
    )
      dispatch(
        fetchFilteredTableDataInit({
          pageSize,
          currentPage,
          activeTab,
          startDate,
          endDate,
          searchFields,
        }),
      );
    else
      dispatch(getOperationDataInit({ name: activeTab, startDate, endDate }));
  };

  const postData = async () => {
    var selectedAssignee = data.assignee.find(
      (obj) => String(obj.assigneeId) === String(payloadData.assigneeId),
    );

    var payload = {
      customerId: callId, // callId is memberId
      issueId: data.issueId,
      status: payloadData.status,
      assigneeName: selectedAssignee ? selectedAssignee.assigneeName : "", // Use the selectedAssignee safely
      assigneeId: Number(payloadData.assigneeId),
      callId: data.callId,
    };

    console.log("Posting data payload:", payload);

    try {
      // Dispatch the action and await the result
      handleSendMessage();
      dispatch(postWorkScreenData(payload));

      setIsUpdated(true);
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  const handleNavigate = () => {
    if (data) {
      const memberId = data.memberId?.replace(/\s+/g, "") || "defaultId";
      console.log("Navigating to memberId:", memberId);
      navigate(`/detailsPage/${memberId}`);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target; // Destructure the name and value correctly
    setPayloadData({
      ...payloadData,
      [name]: value, // Update the corresponding field in payload dynamically
    });
    console.log("value is ", value);
    if (value === "Open" || value === "Yes") {
      setStatusColour("#FEDAD9");
    } else if (value === "In-Progress") {
      setStatusColour("#E8F0FB");
    } else if (value === "Closed") {
      setStatusColour("#FDEBF9");
    }
  };
  const customerContactNumber =
    workScreenData?.issueId?.match(/\d+/)?.[0] || "N/A";

  return (
    <div className="WS-workscreen">
      <Button
        className="WS-link-btn"
        onClick={handleShow}
        disabled={disabled} // Disable the button based on the prop
        // style={{
        //   cursor: disabled ? "not-allowed" : "pointer",
        //   opacity: disabled ? 0.6 : 1,
        // }}
      >
        {value}
      </Button>

      <Modal
        show={show}
        backdrop="static"
        size="lg"
        onHide={handleClose}
        className="WS-modal"
        fullscreen={fullscreen}
      >
        <Draggable
          disabled={!draggable}
          position={fullscreen ? { x: 0, y: 0 } : position}
          onDrag={handleDrag}
          cancel="input, textarea, select, button, option, .no-drag" // Enhanced selector
        >
          <Modal.Body className="WS-modal-body">
            <div className="WS-ribbon">
              <div className="WS-icon-button" onClick={handleMinimize}>
                <FaMinus />
              </div>
              <div className="WS-icon-button" onClick={handleMaximize}>
                <CopyIcon />
              </div>
              <div className="WS-icon-button" onClick={handleClose}>
                <CloseIcon />
              </div>
            </div>
            <div className="WS-issue-header">
              <img src={IssueIcon} className="WS-issue-icon" alt="Issue Icon" />
              <span># Issue - {workScreenData && workScreenData.issueId}</span>
            </div>
            <Container>
              <Row>
                <Col xs={8} md={8}>
                  <Card className="WS-left-card">
                    <div className="WS-collapse-icon2"></div>
                    <div className="WS-issue-details">
                      <div>
                        <span className="WS-detail-label1">
                          Call Category:{" "}
                        </span>

                        <span
                          className="WS-detail-text"
                          style={{
                            border: "2px solid #E1F6FF",
                            padding: "3px",
                            borderRadius: "4.83px",
                            background: "#E1F6FF",
                            marginLeft: "6px",
                          }}
                        >
                          {workScreenData && workScreenData.callCategory}
                        </span>
                      </div>
                      <div className="work-contain">
                        <span className="WS-detail-label">
                          Customer's Name:{" "}
                        </span>
                        <span
                          className="WS-detail-text"
                          style={{ fontWeight: "bold" }}
                        >
                          {workScreenData && workScreenData.customerName}
                        </span>
                      </div>
                      <div className="WS-customer-contact">
                        <span>Customer Contact Number: </span>
                        <span className="field-color">
                          {customerContactNumber}
                        </span>
                      </div>
                      <div>
                        <span className="WS-detail-label">Agent's Name: </span>
                        <span
                          className="WS-detail-text"
                          style={{ fontWeight: "bold" }}
                        >
                          {workScreenData?.agentName || ""}
                        </span>
                      </div>
                      {/* <div>
                        <div className="WS-detail-label2">
                          Change in Subscription
                        </div>
                        <p className="WS-detail-text1">
                          {workScreenData && workScreenData.changeSubscription}
                        </p>
                      </div> */}
                      <div
                        className="CaseDetails"
                        onClick={() =>
                          navigate(`/detailsPage/${callId.replace(/\s+/g, "")}`)
                        }
                      >
                        <GoLink /> Case Details
                      </div>
                      <hr />
                      <div>
                        <div className="WS-tabulation">
                          <button
                            className={`WS-tab-btn ${
                              isNotesOpen ? "selected" : ""
                            }`}
                            onClick={() => {
                              setIsNotesOpen(true);
                              setChats(workScreenData.notes);
                            }}
                          >
                            Notes
                          </button>
                          <button
                            className={`WS-tab-btn ${
                              isNotesOpen ? "" : "selected"
                            }`}
                            onClick={() => {
                              setIsNotesOpen(false);
                              setChats(workScreenData.history);
                            }}
                          >
                            History
                          </button>
                        </div>
                        <HistorySection sizeLg={!isNotesOpen} chats={chats} />
                        {isNotesOpen && (
                          <InputGroup className="mt-3 no-drag">
                            <Form.Control
                              type="text"
                              placeholder="Reply or post an Update"
                              value={newMessage}
                              onChange={(e) => setNewMessage(e.target.value)}
                              onKeyDown={handleKeyDown}
                              className="custom-placeholder no-drag"
                            />
                            {/* <img src={WorkBtnImg} onClick={handleSendMessage} /> */}

                            {/* <Button onClick={handleSendMessage} variant="primary">
                            Send
                          </Button> */}
                          </InputGroup>
                        )}
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col xs={4} md={4}>
                  <Card className="WS-right-card">
                    <button
                      className="WS-download-btn"
                      onClick={handleDownload}
                      disabled={disabled} // Disable the download button based on the prop
                      // style={{
                      //   cursor: disabled ? "not-allowed" : "pointer",
                      //   opacity: disabled ? 0.6 : 1,
                      // }}
                    >
                      <img src={DownloadIcon} alt="Download All" />
                      Download All
                    </button>

                    <div className="WS-select-field-status">
                      <label className="WS-select-label">Status:</label>
                      <div
                        className="custom-selection"
                        style={{
                          border: "2px solid #EBEBEB",
                          width: "115px",
                          height: "38px",
                          padding: "3px",
                          borderRadius: "5px",
                          marginLeft: "-5px",
                        }}
                      >
                        <select
                          value={payloadData.status}
                          onChange={handleChange}
                          name="status"
                          style={{
                            border: "2px solid #EBEBEB",
                            backgroundColor: statusColour,
                            borderRadius: "10px",
                            width: "90px",
                            border: "none",
                            outline: "none",
                            height: "28px",
                            fontSize: "11px",
                            fontWeight: "550",
                            marginLeft: "5px",
                            marginTop: "1px",
                            textAlign: "center",
                            color:
                              payloadData.status === "Open"
                                ? "#8E1F0B" // Set text color for Open
                                : payloadData.status === "In-Progress"
                                  ? "#3786F1" // Set text color for In-Progress
                                  : payloadData.status === "Closed"
                                    ? "#EE61CF" // Set text color for Closed
                                    : "#8E1F0B", // Default text color
                          }}
                        >
                          {statusOptions?.map((obj) => (
                            <option
                              key={obj.value}
                              value={obj.value}
                              style={{
                                backgroundColor: "white",
                                color: "black",
                              }}
                            >
                              {obj.text}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="WS-select-field">
                      <label className="WS-select-label">Assignee:</label>
                      <div className="custom-select">
                        <select
                          value={payloadData.assigneeId}
                          onChange={handleChange}
                          name="assigneeId"
                          style={{
                            border: "2px solid #EBEBEB",
                            width: "136px",
                            height: "38px",
                            padding: "2px",
                            borderRadius: "5px",
                            marginLeft: "7px",
                            fontSize: "11px",
                          }}
                        >
                          {workScreenData?.assignee &&
                            workScreenData.assignee.map((obj, index) => (
                              // <option key={index} value={obj.assigneeId}>
                              //   {obj.assigneeName}
                              // </option>
                              <option key={index} value={obj.assigneeId}>
                                <span style={{ color: "#D8D8D8" }}>
                                  &#9899; {/* Black Circle */}
                                </span>
                                {obj.assigneeName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </Card>
                </Col>
              </Row>
            </Container>
            <Button
              className="WS-save-btn"
              type="button"
              onClick={postData}
              disabled={disabled} // Disable the save button based on the prop
              style={{
                cursor: disabled ? "not-allowed" : "pointer",
                opacity: disabled ? 0.6 : 1,
              }}
            >
              Save
            </Button>
            {downloadVisible && (
              <Download
                data={workScreenData}
                onDownloadComplete={() => setDownloadVisible(false)}
              />
            )}
          </Modal.Body>
        </Draggable>
      </Modal>
    </div>
  );
}

// Define PropTypes for better type checking
WorkScreen.propTypes = {
  value: PropTypes.string.isRequired, // Adjust based on actual data type
  callId: PropTypes.string.isRequired, // Adjust if it's a number
  disabled: PropTypes.bool,
};

// Define default props
WorkScreen.defaultProps = {
  disabled: false,
};

export default WorkScreen;
